module.exports = __webpack_public_path__ + "dimer/static/img/MrYCQ.2114aec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MrYCQ.jpg
// module id = 1Y/2
// module chunks = 0